{
  "title": "Учасники",
  "description": "Усі в цій школі — персонал, учні та батьки.",
  "invite": "Запросити",
  "searchPlaceholder": "Пошук за іменем або поштою…",
  "tabs": {
    "members": "Учасники",
    "invitations": "Запрошення",
    "family": "Родинні зв’язки"
  },
  "filters": {
    "status": "Статус",
    "allStatuses": "Усі статуси",
    "active": "Активні",
    "inactive": "Деактивовані",
    "segment": "Кого показати",
    "allClasses": "Усі класи",
    "schoolClass": "Клас"
  },
  "table": {
    "name": "Ім'я",
    "email": "Ел. пошта",
    "role": "Роль",
    "joined": "Приєднання",
    "status": "Статус"
  },
  "status": {
    "active": "Активний",
    "inactive": "Деактивований"
  },
  "empty": {
    "title": "Учасників не знайдено",
    "text": "Запросіть вчителів, учнів і батьків, щоб наповнити школу.",
    "filterText": "За цими фільтрами нічого не знайдено."
  },
  "actions": {
    "deactivate": "Деактивувати",
    "reactivate": "Активувати знову",
    "deactivateTitle": "Деактивувати {{name}}?",
    "deactivateDescription": "Людина втратить доступ до цієї школи, але її історія збережеться. Ви зможете активувати її знову будь-коли.",
    "reactivateTitle": "Активувати {{name}} знову?",
    "reactivateDescription": "Людина знову отримає доступ до цієї школи з тією самою роллю.",
    "deactivated": "Учасника деактивовано",
    "reactivated": "Учасника активовано знову",
    "setPassword": "Задати пароль"
  },
  "family": {
    "add": "Додати зв’язок",
    "unlink": "Роз’єднати",
    "unlinked": "Зв’язок видалено",
    "unlinkTitle": "Роз’єднати {{parent}} та {{pupil}}?",
    "unlinkDescription": "Батьки втратять доступ до робіт цього учня й більше не зможуть йому писати. Записи самого учня залишаться недоторканими, а зв’язок можна буде створити знову.",
    "filters": {
      "pupil": "Учень",
      "allPupils": "Усі учні",
      "parent": "Хтось із батьків",
      "allParents": "Усі батьки",
      "clear": "Скинути фільтри"
    },
    "table": {
      "pupil": "Учень",
      "parent": "Хтось із батьків",
      "linked": "Створено"
    },
    "empty": {
      "title": "Ще немає родинних зв’язків",
      "text": "Додайте зв’язок між дитиною та її батьками, щоб вони бачили її навчання. Коли батьки приймають запрошення, зв’язок створюється сам — тут ви додаєте родини, які вже є у школі.",
      "filterTitle": "За цими фільтрами зв’язків немає",
      "filterText": "Для цього учня чи цих батьків зв’язків не записано. Скиньте фільтри, щоб побачити всю школу."
    },
    "dialog": {
      "title": "Новий родинний зв’язок",
      "description": "Оберіть учня та когось із його батьків. Обидва вже мають бути учасниками цієї школи.",
      "pupilPlaceholder": "Оберіть учня",
      "parentPlaceholder": "Оберіть когось із батьків",
      "pupilRequired": "Оберіть учня",
      "parentRequired": "Оберіть когось із батьків",
      "noPupils": "У школі ще немає учнів — спершу запросіть їх.",
      "noParents": "Ще немає батьків серед учасників — спершу запросіть їх.",
      "submit": "Додати",
      "success": "Зв’язок створено"
    }
  },
  "segments": {
    "staff": "Персонал",
    "pupil": "Учні",
    "parent": "Батьки"
  },
  "createPupil": {
    "open": "Створити акаунт учня",
    "title": "Створення акаунта учня",
    "description": "Для учнів без робочої пошти: вигадайте шкільний email-логін, задайте пароль і передайте дані учневі. Тих, у кого є справжня адреса, краще запросити звичайним способом.",
    "firstName": "Імʼя",
    "lastName": "Прізвище",
    "email": "Email-логін",
    "emailHint": "Це логін, а не поштова скринька — адреса одразу позначається підтвердженою, тому ніколи не вводьте чиюсь справжню адресу.",
    "password": "Пароль",
    "regenerate": "Згенерувати новий пароль",
    "submit": "Створити акаунт",
    "cancel": "Скасувати",
    "firstNameRequired": "Вкажіть імʼя.",
    "lastNameRequired": "Вкажіть прізвище.",
    "emailInvalid": "Введіть логін у форматі email.",
    "passwordTooShort": "Щонайменше 8 символів."
  },
  "setPassword": {
    "title": "Новий пароль для {{name}}",
    "description": "Новий пароль одразу замінює старий. Скопіюйте його й передайте учневі — він показується лише раз.",
    "password": "Новий пароль",
    "regenerate": "Згенерувати новий пароль",
    "submit": "Задати пароль",
    "cancel": "Скасувати"
  },
  "credentials": {
    "warning": "Показується лише раз — скопіюйте дані зараз і передайте учневі. Якщо закриєте вікно без копіювання, доведеться задати новий пароль.",
    "label": "Логін і пароль",
    "copy": "Скопіювати дані",
    "copied": "Дані скопійовано.",
    "copyFailed": "Не вдалося скопіювати — виділіть і скопіюйте вручну.",
    "acknowledge": "Готово, я скопіював"
  }
}
